import type { CadenceDaySummary } from "../../api/cadence.ts";

export const CADENCE_TODAY_REFRESH_EVENT = "wcrm:cadence-today-refresh";

export function emitCadenceTodayRefresh(summary?: CadenceDaySummary): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<CadenceDaySummary | undefined>(
    CADENCE_TODAY_REFRESH_EVENT,
    { detail: summary },
  ));
}
